import React, { useState } from "react";
import styles from "./styles.module.scss";
import { useRouter } from "next/router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { handleHamburgerClicked } from "../../../../utils/helperEventFunctions";
import SideNavigation from "../../../side-navigation/Side-Navigation";
import useStore from "../../../../store/UseStore";
import DownloadTheAppCTA from "../Common/DownloadTheAppCTA";

export default function Header({ anonymousId }) {
  const router = useRouter();
  const [showSideMenu, setShowSideMenu] = useState(false);
  const { webViewEventState } = useStore();
  const currentUser = useSelector((state) => state?.currentUser?.currentUser);
  const isCurrentUserPremium = currentUser?.is_premium;
  const firebase_uid = useSelector((state) => state?.currentUser?.firebaseUID);

  const toggleSideMenu = () => {
    setShowSideMenu((prev) => !prev);
    // setShowIphoneBanner(!showIphoneBanner);
    handleHamburgerClicked({
      firebase_uid,
      screen: window.location.href,
      webviewEvent: webViewEventState,
    });
  };

  return (
    <header className="bg-black z-[200] fixed w-full">
      {/* {isCurrentUserPremium && showIphoneBanner ? (
        <div className="lg:!hidden">
          <IPhoneTopBanner />
        </div>
      ) : null} */}
      <div className={styles.header}>
        <div className={styles.logo}>
          <img
            onClick={() => router.push("/")}
            alt="logo-image"
            src={"/assets/headerlogo.webp"}
            className="w-[40%]"
          />
        </div>

        {/* // Desktop Nav */}
        <div className="hidden lg:block">
          <div className={styles.navigation}>
            <div className={styles.wtach_series}>
              <a href="/app">Watch Videos</a>
            </div>
            {!isCurrentUserPremium && (
              <div className={styles.suscribe}>
                <a href="/contact-us">Contact Us</a>
              </div>
            )}
            <div className={styles.team_culture}>
              <a href="/team">Team and Culture</a>
            </div>
            <div className={styles.team_culture}>
              <a href="/blog">Blogs</a>
            </div>
            {/* {userData || globalState?.userFullInformation?.user ? (
              <a className={styles.joinUs} onClick={handleLogout}>
                Logout
              </a>
            ) : (
              <a className={styles.joinUs} href="/login">
                Login
              </a>
            )} */}
            <DownloadTheAppCTA
              animate={false}
              anonymousId={anonymousId}
              onSection="Navbar"
              className="!px-2 !py-1.5 rounded-md text-[14.5px]"
            />
          </div>
        </div>

        {/* // Mobile Nav */}
        <div className="lg:hidden">
          <div className={styles.menuIcon}>
            {!showSideMenu ? (
              <FontAwesomeIcon
                icon={faBars}
                style={{ width: 26, height: 26 }}
                onClick={toggleSideMenu}
                className="text-white"
              ></FontAwesomeIcon>
            ) : (
              <div onClick={toggleSideMenu}>
                <svg
                  width="30px"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>cross-white</title>
                  <g fill="none" fillRule="evenodd">
                    <path d="M0 0h24v24H0z"></path>
                    <path
                      d="M6 6l12.73 12.73m0-12.73L6 18.73"
                      stroke="#fff"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </g>
                </svg>

                <SideNavigation
                  anonymousId={anonymousId}
                  showSideMenu={showSideMenu}
                  toggleSideMenu={toggleSideMenu}
                  openLogin={() => {}}
                  type="landing"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
